export default __webpack_public_path__ + "static/media/Filternew.7c9160b2.svg";